import { client, getErrorMessage } from "common-lib";

const baseUrl = "/projects";

export const getLatestInspResult = async (projectId: number, modelUuid?: string, state?: string) => {
  try {
    const response = await client.get(`${baseUrl}/${projectId}/images/result`, {
      params: { model_uuid: modelUuid, state },
    });
    return response.data;
  } catch (error: any) {
    // throw new Error(getErrorMessage(error));
    console.error(error);
  }
};
